/**
 * @file 新闻列表页常量
 * @author FengGuang(fengguang01@baidu.com)
 */
import {ITagItem} from './type';


export const SELECT_ALL_TAG: ITagItem = {
    id: 0,
    name: '全部',
    link: ''
};
